import { getTotal } from 'reducers/ShoppingCart';
import { getSetting } from 'reducers/configs/settings';
import {
  getCurrentSalesDocPayments,
  getIsCurrentSaleAReturn,
  getReturnTotal,
} from 'reducers/sales';
import { PosPlugin } from 'plugins/plugin';

import {
  getGivexConfiguration,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getIsAllowed,
} from './configuration/Configuration';

type OnOpenPaymentModalAp = Parameters<
  Required<Required<PosPlugin>['onOpenPaymentModal']>['on']
>[1];

/**
 * Util function, used to remove the "Givex" payment from list of payments while using the paymentLimits, that the same hook has edited and passed via `ap`
 *
 * When changing logic in {@link getIsAllowed }, this one has to be changed as well but still use edited limits
 *
 * @param ap the arguments, passed to the `onOpenPaymentModal.on`, edited by the plugin
 * @returns Boolean that determines if the givex payment should be removed from list of payments based on edited limits and givex plugin conf
 */
export const checkIfGivexIsAllowedBasedOnAp = (
  ap: OnOpenPaymentModalAp,
): ((state) => boolean) => state => {
  const isAReturn = getIsCurrentSaleAReturn(state);
  const returnTotal = getReturnTotal(state);
  const total = getTotal(state);
  const originalTenderOnly = getSetting(
    'pos_allow_return_receipt_original_tender_only',
  )(state);
  const currentSalesDocPayments = getCurrentSalesDocPayments(state);
  const conf = getGivexConfiguration(state);
  const giftCardLimitFromAp = ap.paymentLimits.find(
    limit => limit.serial && limit.type === 'GIFTCARD',
  );
  const serialGiftCardDisabled =
    giftCardLimitFromAp && giftCardLimitFromAp.amount < 0;
  const shoppingCartTotal = isAReturn ? returnTotal : total;
  if (isAReturn) {
    if (originalTenderOnly) {
      return currentSalesDocPayments.some(
        originalPayment => originalPayment.cardType === 'GIVEX',
      );
    }
    // Check both the plugin config and the POS config - if either blocks, then block
    return conf.isAllowedOnReturnWithReceipt && !serialGiftCardDisabled;
  }
  if (shoppingCartTotal < 0) {
    return conf.isAllowedOnReturnWithoutReceipt;
  }
  return conf.isAllowedOnSale;
};
